<template>
  <path
    d="M17.63 5.84018C17.27 5.33018 16.67 5.00018 16 5.00018L5 5.01018C3.9 5.01018 3 5.90018 3 7.00018V17.0002C3 18.1002 3.9 18.9902 5 18.9902L16 19.0002C16.67 19.0002 17.27 18.6702 17.63 18.1602L21.59 12.5802C21.84 12.2302 21.84 11.7702 21.59 11.4202L17.63 5.84018Z"
  />
</template>
